import React from "react";
import { RECORDED_CONTENT_VIDEO_SOURCE } from "../../../../../schedule-v2/RecordedContent/recordedContent.data";
import VdoCipherNormalVideo from "../../../../../schedule-v2/components/recorded-content/ContentRow/VdoCipherNormalVideo/VdoCipherNormalVideo";
import DrmVideo from "../../../../../schedule-v2/components/recorded-content/ContentRow/DrmVideo";
import BasicVideoPlayer from "../../../../../schedule-v2/components/recorded-content/ContentRow/BasicVideoPlayer";

export const ExlyDynamicVideoPlayer = ({
  videoLink,
  videoSource,
  isZoomRecording,
  className,
}) => {
  let videoComponent;

  switch (videoSource) {
    case RECORDED_CONTENT_VIDEO_SOURCE.VDOCIPHER_NON_DRM:
      videoComponent = <VdoCipherNormalVideo videoId={videoLink} />;
      break;
    case RECORDED_CONTENT_VIDEO_SOURCE.VDOCIPHER_DRM:
      videoComponent = <DrmVideo content={videoLink} />;
      break;
    default:
      videoComponent = (
        <BasicVideoPlayer isZoomRecording={isZoomRecording} url={videoLink} />
      );
  }

  return (
    <div className={`exlyDynamicVideo${className ? ` ${className}` : ""}`}>
      {videoComponent}
    </div>
  );
};
